/**
 * Frontend configuration for different environments
 */

interface AppConfig {
  apiUrl: string;
  websocketUrl: string;
  isDevelopment: boolean;
  isProduction: boolean;
}

// Detect environment
const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

// Get base URL for the current environment
const getBaseUrl = (): string => {
  if (isDevelopment) {
    // Development: use environment variables or default to localhost, then append /api
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';
    return `${baseUrl.replace(/\/$/, '')}/api`; // Remove trailing slash and add /api
  } else {
    // Production: use current origin with /api prefix (same domain deployment)
    return `${window.location.origin}/api`;
  }
};

// Get WebSocket URL for the current environment
const getWebSocketUrl = (): string => {
  if (isDevelopment) {
    // Development: use environment variables or default to localhost
    return process.env.REACT_APP_WS_URL || 'ws://localhost:8080/ws/conversation';
  } else {
    // Production: use current origin with appropriate protocol
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}/ws/conversation`;
  }
};

// Create configuration object
const config: AppConfig = {
  apiUrl: getBaseUrl(),
  websocketUrl: getWebSocketUrl(),
  isDevelopment,
  isProduction,
};

// Log configuration in development
if (isDevelopment) {
  console.log('App Configuration:', config);
}

export default config;
export type { AppConfig };
